export default "__VITE_ASSET__527aa9d0__"